module.exports = __webpack_public_path__ + "img/max-office-building-edit.c23a08f2.svg";